import { deleteDevice, myDeviceList } from "@/apis/user";
import { Toast } from "antd-mobile";
import { useState } from "react";

export type Device = {
  deviceModel: string;
  isFirst: number;
  lastLoginIp: string;
  lastLoginIpLong: string;
  lastLoginTime: string;
  operatingSystem: string;
  ownerId: number;
  ownerType: string;
  uuid: string;
};

export const useLogic = () => {
  const [list, setList] = useState<Device[]>();
  const fetchList = async () => {
    const result = await myDeviceList({ page: 1, pageSize: 50 });
    if (result.ok) {
      setList(result.data.list);
    } else {
      return Toast.show("获取设备失败！");
    }
  };

  const fetchDeleteDevice = async (uuid: string) => {
    const result = await deleteDevice({ uuid });
    if (result.ok) {
      Toast.show(result.msg);
      fetchList();
    } else {
      Toast.show(result.msg);
    }
  };
  return {
    list,
    fetchList,
    fetchDeleteDevice,
  };
};
